<template>
  <FeatureFlagSwitcher :flag="Feature_Flags.PORTAL_LOYALTY_REVAMP">
    <template #new>
      <LoyaltyEnhancedCollection />
    </template>
    <template #old>
      <LoyaltyCollection />
    </template>
  </FeatureFlagSwitcher>
</template>

<script>

import LoyaltyEnhancedCollection from './V2/components/Collection.vue';
import LoyaltyCollection from './components/Collection.vue';
import { Feature_Flags } from '@/enums/globals';

export default {
  name: 'LoyaltyCollectionFlagSwitcher',
  components: {
    LoyaltyEnhancedCollection,
    LoyaltyCollection,
  },
  data() {
    return { Feature_Flags };
  }
};
</script>
